import mustache from "mustache";
import { IConnectRender } from "../../definitions/IConnectRender";
import { SectionConfig } from "../../definitions/section/SectionConfig";
import template from "./sectionTemplate.html";

mustache.parse(template);

/** Contador para ids únicos por instancia. */
let SECTION_ID = 0;

/** Sección (Render/Connect): cabecera reutilizable (label / título / subtítulo +
 *  acción opcional) y un contenido que define la subclase (`renderContent` /
 *  `connectContent` / `disposeContent`). */
export abstract class SectionRender implements IConnectRender {
  /** Id único de la instancia (para los ids del DOM). */
  private readonly _sectionId: number;
  /** Config de la cabecera. */
  private readonly _section: SectionConfig;

  /** @param section Config de la cabecera de la sección. */
  constructor(section: SectionConfig) {
    SECTION_ID += 1;
    this._sectionId = SECTION_ID;
    this._section = section;
  }

  /** HTML del contenido bajo la cabecera (lo aporta la subclase). */
  protected abstract renderContent(): string;
  /** Conecta el contenido (listeners, carga async…). */
  protected abstract connectContent(): void;
  /** Dispone el contenido. */
  protected abstract disposeContent(): void;

  /** Cabecera + contenido embebido. */
  render(): string {
    return mustache.render(template, {
      id: this._sectionId,
      label: this._section.label,
      title: this._section.title,
      subtitle: this._section.subtitle,
      addLabel: this._section.addLabel,
      content: this.renderContent(),
    });
  }

  /** Conecta el contenido y cablea el botón de acción primaria. */
  connect(): void {
    this.connectContent();
    if (this._section.onAdd) {
      this._addBtn = document.getElementById(`section-add-${this._sectionId}`);
      this._addBtn?.addEventListener("click", this._onAdd);
    }
  }

  /** Libera el botón y dispone el contenido. */
  dispose(): void {
    this._addBtn?.removeEventListener("click", this._onAdd);
    this.disposeContent();
  }

  /** Botón de acción primaria (disponible tras `connect`, si hay `onAdd`). */
  private _addBtn: HTMLElement | null = null;

  private _onAdd = (): void => this._section.onAdd?.();
}
